<template>
  <b-container>

    <h2>Auroras.live Settings</h2>

    <b-row>
      <b-col>
        <h3>Widget Settings</h3>
        <p>If you wish to reset the widgets back to default, use the button below.</p>
        <b-button size="sm" @click="resetWidgets">Reset Widgets</b-button>
      </b-col>
      <!-- <b-col>
        <p>
          <b-form-input v-model="tz"></b-form-input>
          <b-button @click="saveTimezone">Save Timezone</b-button>
        </p>
      </b-col> -->
    </b-row>
  </b-container>
</template>

<script>

  export default {
    name: 'settings',
    data() {
      return {
        tz: (window.localStorage.getItem('auroraslive-tz') || (new Date).getTimezoneOffset())
      }
    },
    methods: {
      track () {
        this.$ga.page(this.$route.path)
      },
      resetWidgets: function() {
        window.localStorage.removeItem('auroraslive-widget-layout')
        window.location.reload()
      },
      saveTimezone: function() {
        window.localStorage.setItem('auroraslive-tz', this.tz)
      }
    }
  }
</script>
